import {
  ProgrammaticCampaign,
  SortDirection,
  DSPProvider,
} from "@intentsify/types";
import { Badge } from "components";
import { FetchDataParamsWithToken } from "types";
import { combineParamsAndFilters } from "utils";
import { listPaginatedProgrammaticCampaigns } from "../displayPerformance.requests";

export const defaultFetchDataParams: FetchDataParamsWithToken<
  keyof ProgrammaticCampaign
> = {
  order: SortDirection.ASC,
  order_by: "isEnded",
  pageToken: "",
};

export const listCampaigns =
  (dspProviders: DSPProvider[]) =>
  async (
    params: FetchDataParamsWithToken<keyof ProgrammaticCampaign, undefined> & {
      pageSize?: number;
    }
  ) => {
    const paramsAndFilters = combineParamsAndFilters({
      ...params,
      dspProvider: dspProviders,
    });

    const { data, nextPageToken } = await listPaginatedProgrammaticCampaigns(
      paramsAndFilters
    );

    return {
      nextPageToken,
      results: data.map((c) => ({
        value: c.id,
        label: c.displayName,
        companyId: c.companyId,
        meta: {
          renderListItemAdditionalContent: () => {
            const text = c.isEnded ? "Ended" : "Active";
            const backgroundColor = c.isEnded ? "brand.50" : "green.600";
            return (
              <Badge
                height="23px"
                lineHeight="23px"
                width={55}
                textAlign="center"
                backgroundColor={backgroundColor}
              >
                {text}
              </Badge>
            );
          },
        },
      })),
    };
  };
